import { useContext } from "react";
import { useCodeEditor } from "src/hooks/useCodeEditor";
import { CursorContext } from "src/providers/CursorProvider";
import { TextContext } from "src/providers/TextProvider";

export default function ReactCodeEditor() {
  const { text, setText } = useContext(TextContext);
  const { setCursor } = useContext(CursorContext);

  const ref = useCodeEditor({
    value: text,
    onChange: setText,
    onChangeCursor: setCursor,
  });

  return <div ref={ref} />;
}
